import { useStores } from "../../../../models/helpers/useStores"
import LikeButton from "../../../atoms/LikeButton"
import styles from "./styles.module.scss"
import { observer } from "mobx-react-lite"
import { TripSearchResult } from "@cruisen/contract"
import classNames from "classnames"

export const CruiseDetailsFooter = observer(function CruiseDetailsFooter({
  cruise,
  isSelected,
  onClick,
}: {
  cruise: TripSearchResult
  isSelected: boolean
  onClick: () => void
}) {
  const rootStore = useStores()

  return (
    <div className={styles.cruiseDetailsFooter}>
      <div className={styles.mainRow}>
        <LikeButton
          userId={rootStore.loggedInUser.id}
          tripId={rootStore.activeTrip.id}
          tripSearchId={cruise.tripSearchId}
          docId={cruise.id}
          cruiseLikes={cruise.likes}
          testId={"cruise-details-footer-like-button"}
        />
        <div className={styles.buttonRow}>
          <button
            className={classNames(
              styles.selectCruiseButton,
              isSelected && styles.selectCruiseButtonSelected,
            )}
            data-testid={"select-cruise-button"}
            onClick={onClick}
          >
            {isSelected ? "Unselect" : "Select"}
          </button>
        </div>
      </div>
    </div>
  )
})
